import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfXIconProps extends SvgIconProps {}

/**
 * Component display X icon
 * @param props -CcfXIconProps
 * @returns svg X icon
 * @example -<CcfXIcon/>
 */
export function CcfXIcon(props: CcfXIconProps) {
  return (
    <SvgIcon width="26" height="26" viewBox="0 0 26 26" fill="none" {...props}>
      <path
        d="M18.4187 5.32809H6.84717C5.7426 5.32809 4.84717 6.22352 4.84717 7.32809V18.8996C4.84717 20.0042 5.7426 20.8996 6.84717 20.8996H18.4187C19.5232 20.8996 20.4187 20.0042 20.4187 18.8996V7.32809C20.4187 6.22352 19.5232 5.32809 18.4187 5.32809Z"
        fill="black"
      />
      <path
        d="M15.7357 8.23692H17.3903L13.7754 12.3686L18.0281 17.9908H14.6983L12.0902 14.581L9.10605 17.9908H7.4504L11.3169 13.5716L7.2373 8.23692H10.6517L13.0091 11.3537L15.7357 8.23692ZM15.1549 17.0004H16.0718L10.1535 9.17529H9.16958L15.1549 17.0004Z"
        fill="white"
      />
    </SvgIcon>
  );
}

export default CcfXIcon;
